import PubNub from 'pubnub';

// 1 minutes
const networkRecoveryTimeout = 60000;

let needNetworkRecovery = false;

export default async function setupPubNub(
  getEventSubscriptionInfoCB,
  onMessage,
  onNetworkRecovery
) {
  let pubnub;
  let previousSubscribeKey;
  let nextRefreshToken;

  const refreshSubscriptionInfo = async () => {
    clearTimeout(nextRefreshToken);

    let subscriptionInfo;
    let previousPubnub;

    try {
      subscriptionInfo = await getEventSubscriptionInfoCB();
    } catch (err) {
      // user anonymous: we don't subscribe
      if (err.response && err.response.status === 403) return;

      console.error('Error while subscribing to PubNub :', err.message);

      // Retry
      nextRefreshToken = setTimeout(refreshSubscriptionInfo, networkRecoveryTimeout);
      needNetworkRecovery = true;

      return;
    }

    const { subscribeKey, userId, channels, ttl, token } = subscriptionInfo;
    const hasSubscribeKeyChanged = previousSubscribeKey && previousSubscribeKey !== subscribeKey;

    if (!pubnub || hasSubscribeKeyChanged) {
      previousSubscribeKey = subscribeKey;
      previousPubnub = pubnub;
      pubnub = new PubNub({ subscribeKey, userId, ssl: true, restore: true });

      pubnub.addListener({
        message: message => onMessage(message.message),
        status: status => {
          if (status.category === 'PNAccessDeniedCategory') {
            refreshSubscriptionInfo();
          } else if (
            onNetworkRecovery &&
            ['PNNetworkUpCategory', 'PNReconnectedCategory'].includes(status.category)
          ) {
            onNetworkRecovery();
          }
        }
      });
    }

    pubnub.setToken(token);

    try {
      pubnub.subscribe({ channels });
    } catch (err) {
      console.error('Error while subscribing to PubNub :', err.message);

      // Retry
      nextRefreshToken = setTimeout(refreshSubscriptionInfo, networkRecoveryTimeout);
      needNetworkRecovery = true;

      return;
    }

    if (previousPubnub != null) {
      previousPubnub.removeAllListeners();
      previousPubnub.destroy();
    }

    if (needNetworkRecovery) {
      needNetworkRecovery = false;
      onNetworkRecovery();
    }

    nextRefreshToken = setTimeout(refreshSubscriptionInfo, getRefreshDelay(ttl));
  };

  await refreshSubscriptionInfo();
}

// Min value : 1 minute
const getRefreshDelay = ttl => Math.max(1, ttl - 1) * 60000;
